import React, {FunctionComponent} from "react";
import {Environment, QueryRenderer} from "react-relay";
import {graphql} from "relay-runtime";
import {relayAuthEnvironment} from "@/RelayEnvironment";
import LoginExpiredModal from "@/Components/LoginExpiredModal/LoginExpiredModal";
import LoadingElement from "@/Components/Loading/LoadingElement";
import EditComponentTranslationPopup from "@/Components/EditComponentTranslation/EditComponentTranslation";


interface IEditComponentTranslationQueryRenderer {
    isOpen: string;
    setIsOpen: any;
    setEdges: any;
    node: any;
    lang: string;
    edges: any;
}


const EditComponentTranslationQueryRenderer: FunctionComponent<IEditComponentTranslationQueryRenderer> = ({
                                                                                                              isOpen,
                                                                                                              setIsOpen,
                                                                                                              node,
                                                                                                              setEdges,
                                                                                                              lang,
                                                                                                              edges,
                                                                                                          }): JSX.Element => {
    return (
        <QueryRenderer<EditComponentTranslationQueryRendererQuery>
            //@ts-ignore
            environment={relayAuthEnvironment() as Environment}
            query={graphql`
            query EditComponentTranslationQueryRendererQuery($component: String!, $lang: String!) {
                viewer {
                    userId                              
                }
                translation(component: $component, lang: $lang) {
                    text
                }
            }
            `}
            cacheConfig={{force: true}}
            variables={{
                component: edges.component,
                lang: edges.lang
            }}
            render={(result) => {
                if (result.props?.viewer === null) {
                    return <LoginExpiredModal/>;
                }

                if (!result.props?.viewer) {
                    return <LoadingElement/>;
                }

                return (
                    <>
                        <EditComponentTranslationPopup
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            node={node}
                            text={result.props.translation.text}
                            lang={edges.lang}
                            edges={edges}
                            setEdges={setEdges}/>
                    </>
                );
            }}
        />
    );
};

export default EditComponentTranslationQueryRenderer;
